import * as React from 'react';
import { SearchIcon, XIcon } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';

export function ScreenSearch({ value, onChange, count }: {
  value: string; onChange: (value: string) => void; count: number;
}) {
  const input = React.useRef<HTMLInputElement>(null);
  const statusId = React.useId();
  return <div className="space-y-2 px-2 pt-2">
    <label className="text-xs font-medium" htmlFor={statusId + '-input'}>Find a screen</label>
    <div className="relative">
      <SearchIcon aria-hidden className="text-muted-foreground pointer-events-none absolute left-2 top-1/2 size-4 -translate-y-1/2" />
      <Input ref={input} id={statusId + '-input'} type="search" value={value}
        onChange={event => onChange(event.target.value)}
        onKeyDown={event => {
          if (event.key === 'Escape' && value) {
            event.preventDefault(); event.stopPropagation(); onChange('');
          }
        }}
        aria-describedby={statusId} placeholder="Name or keyword…" className="pr-9 pl-8 text-sm" />
      {value && <Button type="button" variant="ghost" size="icon" className="absolute top-0 right-0 size-9"
        aria-label="Clear screen search" onClick={() => { onChange(''); input.current?.focus(); }}>
        <XIcon aria-hidden className="size-4" />
      </Button>}
    </div>
    <p id={statusId} role="status" className="text-muted-foreground text-xs">
      {value.trim() ? count ? `${count} ${count === 1 ? 'destination' : 'destinations'} in your menu`
        : 'No matching screens. Clear the search to see your menu.' : 'Search the screens available in your menu.'}
    </p>
  </div>;
}
